import type React from 'react'

const baseProps = {
  width: 18,
  height: 18,
  viewBox: '0 0 18 18',
  fill: 'none',
  stroke: '#2563EB',
  strokeWidth: '1.5',
}

export const CashIcon: React.FC = () => (
  <svg
    {...baseProps}
    width={baseProps.width}
    height={baseProps.height}
    viewBox={baseProps.viewBox}
    fill={baseProps.fill}
    stroke={baseProps.stroke}
    strokeWidth={baseProps.strokeWidth}
  >
    <rect x="2" y="4.5" width="14" height="9" rx="1.5" />
    <circle cx="9" cy="9" r="2.25" />
    <path d="M5 4.5V4M5 13.5V13M13 4.5V4M13 13.5V13" strokeLinecap="round" />
  </svg>
)

export const CreditCardIcon: React.FC = () => (
  <svg
    {...baseProps}
    width={baseProps.width}
    height={baseProps.height}
    viewBox={baseProps.viewBox}
    fill={baseProps.fill}
    stroke={baseProps.stroke}
    strokeWidth={baseProps.strokeWidth}
  >
    <rect x="1.5" y="4" width="15" height="10" rx="2" />
    <path d="M1.5 8h15" strokeLinecap="round" />
    <path d="M4 11h2M8 11h2" strokeLinecap="round" />
  </svg>
)

export const InteracIcon: React.FC = () => (
  <svg
    {...baseProps}
    width={baseProps.width}
    height={baseProps.height}
    viewBox={baseProps.viewBox}
    fill={baseProps.fill}
    stroke={baseProps.stroke}
    strokeWidth={baseProps.strokeWidth}
  >
    <rect x="1.5" y="3" width="15" height="12" rx="2" />
    <path
      d="M1.5 6.5l7.5 5 7.5-5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const PluginIcon: React.FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    stroke="#2563EB"
    strokeWidth="1.5"
  >
    <path
      d="M7 2v3M13 2v3M7 15v3M13 15v3M2 7h3M2 13h3M15 7h3M15 13h3"
      strokeLinecap="round"
    />
    <rect x="5" y="5" width="10" height="10" rx="2" />
  </svg>
)

interface IconProps {
  size?: number
  color?: string
}

export const HelpCircleIcon: React.FC<IconProps> = ({
  size = 13,
  color = '#9CA3AF',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke={color}
    strokeWidth="1.5"
  >
    <circle cx="8" cy="8" r="6.5" />
    <path
      d="M6.25 6a1.75 1.75 0 1 1 2.5 1.6c-.5.24-.75.65-.75 1.15V9.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="8" cy="11.5" r="0.6" fill={color} stroke="none" />
  </svg>
)

export const SettingsIcon: React.FC<IconProps> = ({
  size = 14,
  color = '#2563EB',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke={color}
    strokeWidth="1.5"
  >
    <circle cx="8" cy="8" r="2" />
    <path
      d="M13.2 9.6a1.4 1.4 0 0 0 .28 1.54l.05.05a1.7 1.7 0 1 1-2.4 2.4l-.05-.05a1.4 1.4 0 0 0-1.54-.28 1.4 1.4 0 0 0-.85 1.28v.15a1.7 1.7 0 1 1-3.4 0v-.08a1.4 1.4 0 0 0-.92-1.28 1.4 1.4 0 0 0-1.54.28l-.05.05a1.7 1.7 0 1 1-2.4-2.4l.05-.05a1.4 1.4 0 0 0 .28-1.54 1.4 1.4 0 0 0-1.28-.85h-.15a1.7 1.7 0 1 1 0-3.4h.08a1.4 1.4 0 0 0 1.28-.92 1.4 1.4 0 0 0-.28-1.54l-.05-.05a1.7 1.7 0 1 1 2.4-2.4l.05.05a1.4 1.4 0 0 0 1.54.28h.08a1.4 1.4 0 0 0 .85-1.28v-.15a1.7 1.7 0 1 1 3.4 0v.08a1.4 1.4 0 0 0 .85 1.28 1.4 1.4 0 0 0 1.54-.28l.05-.05a1.7 1.7 0 1 1 2.4 2.4l-.05.05a1.4 1.4 0 0 0-.28 1.54v.08a1.4 1.4 0 0 0 1.28.85h.15a1.7 1.7 0 1 1 0 3.4h-.08a1.4 1.4 0 0 0-1.28.85z"
      strokeLinejoin="round"
    />
  </svg>
)

export const ShieldIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#D97706',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke={color}
    strokeWidth="1.5"
  >
    <path
      d="M8 1.5l5.5 2v4.5c0 3.5-2.4 6-5.5 6.5-3.1-.5-5.5-3-5.5-6.5V3.5L8 1.5z"
      strokeLinejoin="round"
    />
  </svg>
)

export const MailIcon: React.FC<IconProps> = ({
  size = 13,
  color = '#6B7280',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke={color}
    strokeWidth="1.5"
  >
    <rect x="1.5" y="3" width="13" height="10" rx="1.5" />
    <path
      d="M1.5 4.5L8 9l6.5-4.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ShoppingBagIcon: React.FC<IconProps> = ({
  size = 14,
  color = '#6B7280',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke={color}
    strokeWidth="1.5"
  >
    <path
      d="M2.5 4.5h11l-.8 9a1.5 1.5 0 0 1-1.5 1.4H4.8a1.5 1.5 0 0 1-1.5-1.4l-.8-9z"
      strokeLinejoin="round"
    />
    <path
      d="M5.5 4.5V3a2.5 2.5 0 0 1 5 0v1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const DriveThroughIcon: React.FC<IconProps> = ({
  size = 14,
  color = '#6B7280',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 12h4l2-5h6l2 5h4" />
    <path d="M5 12v4h14v-4" />
    <circle cx="8" cy="16" r="1.5" />
    <circle cx="16" cy="16" r="1.5" />
    <path d="M9 7V4h6v3" />
  </svg>
)

export const TruckIcon: React.FC<IconProps> = ({
  size = 14,
  color = '#6B7280',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 16"
    fill="none"
    stroke={color}
    strokeWidth="1.5"
  >
    <rect x="1" y="3" width="9" height="8" rx="1" />
    <path d="M10 6h4l2.5 3v2H10V6z" strokeLinejoin="round" />
    <circle cx="4.5" cy="12.5" r="1.5" />
    <circle cx="13" cy="12.5" r="1.5" />
  </svg>
)

export const PackageIcon: React.FC<IconProps> = ({
  size = 14,
  color = '#6B7280',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke={color}
    strokeWidth="1.5"
  >
    <path d="M2 4.5L8 1.5l6 3v7L8 14.5l-6-3v-7z" strokeLinejoin="round" />
    <path d="M2 4.5L8 7.5l6-3" strokeLinejoin="round" />
    <path d="M8 7.5v7" />
  </svg>
)

export const CheckIcon: React.FC<IconProps> = ({
  size = 14,
  color = '#16A34A',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke={color}
    strokeWidth="2"
  >
    <path d="M3 8.5L6.5 12L13 5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export const XIcon: React.FC<IconProps> = ({
  size = 14,
  color = '#9CA3AF',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke={color}
    strokeWidth="2"
  >
    <path d="M4 4l8 8M12 4l-8 8" strokeLinecap="round" />
  </svg>
)
